// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"181":"ef927fc1f3c94684feb5","666":"48a9a0448ea96ae20351","774":"49ad433fbf4484013445"}[chunkId] + ".js";
};